import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import Skeleton from 'components/Skeleton/Skeleton';
import useStyles from './styles';

const FeaturedInFallback = () => {
  const styles = useStyles({ gridColumns: 5 });
  return (
    <div className={styles.root}>
      <Skeleton className={styles.skeletonTitle} />
      <HorizontalContainer className={styles.centeredContent}>
        <article className={styles.skeletonGrid}>
          <Skeleton className={styles.skeletonItem} />
          <Skeleton className={styles.skeletonItem} />
          <Skeleton className={styles.skeletonItem} />
          <Skeleton className={styles.skeletonItem} />
        </article>
      </HorizontalContainer>
    </div>
  );
};

export default FeaturedInFallback;
